export const ADMIN_ROLE = "admin";
export const TEACHER_ROLE = "teacher";
export const STUDENT_ROLE = "student";
export const USER_ROLE = "user";
